const LAYOUT_LINK_ONLY = "Layout - Link Only";

export { LAYOUT_LINK_ONLY };
